import {RouteConfig} from 'vue-router/types/router';

/** Routes of the takeover offers ("Dauerhafte Übernahme anbieten") */
export const takeoverOfferRoutes: RouteConfig[] = [
    {
        // Monitoring; the view checks read SUBSTITUTION_INQUIRY (like the other substitution views, no route guard)
        path: '/takeover-offers',
        name: 'Übernahme-Angebote',
        component: () => import(/* webpackChunkName: "takeover-offers" */ '@/views/TakeoverOffersView.vue'),
    },
    {
        // Answer page of a takeover offer (signed link with ?t=, also for logged-in employees)
        path: '/takeover-offers/:offerId/:employeeId',
        name: 'Übernahme-Angebot',
        component: () => import(/* webpackChunkName: "takeover-offer-public" */ '@/views/TakeoverOfferPublicView.vue'),
        meta: {
            forAll: true,
            answerPage: true,
            // removing ?t= from the URL must not re-create the view (it would lose the link token)
            keepOnQueryChange: true,
        },
    },
    {
        path: '/settings/takeover-offers',
        name: 'Übernahmeangebote',
        component: () => import(/* webpackChunkName: "takeover-offers" */ '@/views/settings/TakeoverOfferSettings.vue'),
    },
];
